import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'

// React 18 replaced ReactDOM.render with createRoot. StrictMode is back on: the
// legacy context API warning that forced it off came from react-admin 3, which
// no longer applies.
createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>
)
